import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { CommonGroupTag } from '../constants/services.esm.js';
import { LayoutType } from '../types/layouts.esm.js';
import { getTypeAndSelected } from './utilities/get-type-and-selected.esm.js';
import { isValidName } from './utilities/is-valid-name.esm.js';

//This function cleans up old layouts no longer used in this new implementation.

var removeInvalidLayouts = function removeInvalidLayouts(serviceNamespace, delUserEntity) {
  return function (entities) {
    var result = [];
    entities === null || entities === void 0 ? void 0 : entities.forEach(function (entity) {
      if (getTypeAndSelected(entity) === undefined) {
        delUserEntity(serviceNamespace.entityTag, serviceNamespace.groupTag, entity.subgroupTag, entity.instance);
      } else {
        result.push(entity);
      }
    });
    return result;
  };
};

//This function cleans up old layouts no longer used in this new implementation.

var removeLayoutsWithoutColumnNumbers = function removeLayoutsWithoutColumnNumbers(serviceNamespace, delUserEntity) {
  return function (entities) {
    var result = [];
    entities === null || entities === void 0 ? void 0 : entities.forEach(function (entity) {
      var _entity$value, _entity$value$columns;
      if ((_entity$value = entity.value) !== null && _entity$value !== void 0 && (_entity$value$columns = _entity$value.columns) !== null && _entity$value$columns !== void 0 && _entity$value$columns.every(function (c) {
        return Number.isInteger(c) || typeof c === 'string';
      })) {
        result.push(entity);
      } else {
        delUserEntity(serviceNamespace.entityTag, serviceNamespace.groupTag, entity.subgroupTag, entity.instance);
      }
    });
    return result;
  };
};
//This function cleans up old layouts no longer used in this new implementation.
var changeDuplicatedCustomLayouts = function changeDuplicatedCustomLayouts(serviceNamespace, delUserEntity, setUserEntity) {
  return function (entities) {
    var customLayouts = entities === null || entities === void 0 ? void 0 : entities.filter(function (entity) {
      var _entity$value2, _entity$value2$name;
      return !((_entity$value2 = entity.value) !== null && _entity$value2 !== void 0 && (_entity$value2$name = _entity$value2.name) !== null && _entity$value2$name !== void 0 && _entity$value2$name.length);
    });
    var hasMultipleCustomLayouts = customLayouts.length > 1;
    if (!hasMultipleCustomLayouts) {
      return entities || [];
    }
    return entities.map(function (entity, index) {
      var _entity$value3, _entity$value3$name;
      if ((_entity$value3 = entity.value) !== null && _entity$value3 !== void 0 && (_entity$value3$name = _entity$value3.name) !== null && _entity$value3$name !== void 0 && _entity$value3$name.length) {
        return entity;
      }
      if (entity.subgroupTag === CommonGroupTag.current) {
        delUserEntity(serviceNamespace.entityTag, serviceNamespace.groupTag, CommonGroupTag.current, entity.instance);
      }
      if (!entity.value) {
        throw new Error('Invalid entity');
      }
      entity.value.name = entity.value.name || "Saved layout \"".concat(index + 1, "\"");
      entity.subgroupTag = CommonGroupTag.variation;
      entity.value.type = LayoutType.Custom;
      setUserEntity(serviceNamespace.entityTag, serviceNamespace.groupTag, CommonGroupTag.variation, entity.instance, entity.value);
      return entity;
    });
  };
};

//This function cleans up old layouts no longer used in this new implementation.

var changeDuplicatedCurrentLayouts = function changeDuplicatedCurrentLayouts(serviceNamespace, delUserEntity, setUserEntity) {
  return function (entities) {
    var result = [];
    var gotOneSelectedLayout = false;
    entities === null || entities === void 0 ? void 0 : entities.forEach(function (entity) {
      if (entity.subgroupTag !== CommonGroupTag.current) {
        result.push(entity);
      } else {
        if (!gotOneSelectedLayout) {
          gotOneSelectedLayout = true;
          result.push(entity);
        } else {
          var _entity$value4, _entity$value4$name;
          var isCustomLayout = !((_entity$value4 = entity.value) !== null && _entity$value4 !== void 0 && (_entity$value4$name = _entity$value4.name) !== null && _entity$value4$name !== void 0 && _entity$value4$name.length);
          if (isCustomLayout) {
            delUserEntity(serviceNamespace.entityTag, serviceNamespace.groupTag, CommonGroupTag.current, entity.instance);
          } else {
            entity.subgroupTag = CommonGroupTag.variation;
            if (!entity.value) {
              throw new Error('Value cannot be null');
            }
            delUserEntity(serviceNamespace.entityTag, serviceNamespace.groupTag, CommonGroupTag.current, entity.instance);
            setUserEntity(serviceNamespace.entityTag, serviceNamespace.groupTag, CommonGroupTag.variation, entity.instance, entity.value);
            result.push(entity);
          }
        }
      }
    });
    return result;
  };
};

//This function cleans up old layouts no longer used in this new implementation.

var removeInvalidFields = function removeInvalidFields() {
  return function (entities) {
    return entities.map(function (entity) {
      var _value$columns;
      var value = entity.value;
      if (!(value !== null && value !== void 0 && (_value$columns = value.columns) !== null && _value$columns !== void 0 && _value$columns.length)) {
        return entity;
      }
      var columns = value.columns.filter(function (c) {
        return c !== undefined && c !== null;
      });
      return _objectSpread2(_objectSpread2({}, entity), {}, {
        value: _objectSpread2(_objectSpread2({}, value), {}, {
          columns: columns
        })
      });
    });
  };
};

//This function cleans up old layouts no longer used in this new implementation.

var changeCustomLayoutsCalledDefault = function changeCustomLayoutsCalledDefault(serviceNamespace, delUserEntity) {
  return function (entities) {
    var result = [];
    entities === null || entities === void 0 ? void 0 : entities.forEach(function (entity) {
      if (isValidName(entity)) {
        result.push(entity);
      } else {
        delUserEntity(serviceNamespace.entityTag, serviceNamespace.groupTag, entity.subgroupTag, entity.instance);
      }
    });
    return result;
  };
};

export { changeCustomLayoutsCalledDefault, changeDuplicatedCurrentLayouts, changeDuplicatedCustomLayouts, removeInvalidFields, removeInvalidLayouts, removeLayoutsWithoutColumnNumbers };
//# sourceMappingURL=layout-corrections.esm.js.map
